import {BaseContainerModel} from "../../base-container.model";

import {
  bl_wf_issue_user_link_RowClass,
  bl_wf_issue_user_link_RowInterface
} from "../../../dbschema/bl_wf_issue_user_link.model";

export class WfIssueUserLinkContainerModel extends BaseContainerModel {
  bl_wf_issue_user_link: bl_wf_issue_user_link_RowInterface = new bl_wf_issue_user_link_RowClass();
}
